export const defaultFilters = {
  sales: {
    metric: 'hosting',
    period: 'past90Days'
  },
  evaluations: {
    metric: 'hosting',
    period: 'past90Days'
  },
  feedback: {
    metric: 'reason',
    period: 'past90Days'
  },
  conversions: {
    period: 'past90Days'
  },
  renewals: {
    period: 'past90Days'
  },
  churn: {
    period: 'past90Days'
  },
  transactions: {},
  licenses: {},
  'feedback-details': {}
};